var cilSwapVertical = ["512 512", "<path fill='var(--ci-primary-color, currentcolor)' d='M384 433.373V160h-32v274.51l-69.823-69.823-22.627 22.626 107.882 107.883 107.881-107.883-22.626-22.626zM159.432 17.372 51.55 125.255l22.627 22.627L144 78.059V352h32V79.195l68.687 68.687 22.626-22.627z' class='ci-primary'/>"];

export { cilSwapVertical };
//# sourceMappingURL=cil-swap-vertical.js.map
